import * as Icon from 'react-feather';

import { BsChevronDown, BsThreeDots } from 'react-icons/bs';
import { Button, Dropdown } from 'react-bootstrap';
import { Edit, Edit3, Save, X, Video } from 'react-feather';
import React, { useEffect, useState } from 'react';
import {
  getCamera,
  isCancel,
  saveOperationDataDiagram,
  tenantAttributeInfos,
} from '../../pages/Attribute/AttributeSlice';
import { useDispatch, useSelector } from 'react-redux';

import { Radio } from 'antd';
import UploadButton from '../../designs/Button/UploadButton';
import { useTranslation } from 'react-i18next';
import ModalCamera from '../Modal/ModalCamera';

//dd

const EditBar = ({
  setShowDiagram,
  setPreview,
  isDraw,
  setDraw,
  isEdit,
  setEdit,
  setDelete,
  arrMachine,
  setArrMachine,
  deviceId,
  width,
  height,
  dataDiagram,
  isOperation,
  extendCard,
  reload,
  isMaximize,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const arrRectangles = useSelector((state) => state.attribute.rectangles);

  const numberKey = useSelector((state) => state.attribute.numberKey);
  const confirmX = useSelector((state) => state.attribute.confirmX);
  const confirmY = useSelector((state) => state.attribute.confirmY);

  const [disableUpload, setDisableUpload] = useState(false);
  const [showCamera, setShowCamera] = useState(false);

  const editFloat = dataDiagram?.filter((item) => item.type !== 'float');
  const [newArrMove, setNewArrMove] = useState([]);

  const editPoint = dataDiagram?.filter(
    (item) => item.topLeftPoint.x === numberKey
  );

  let index = dataDiagram?.findIndex(
    (elm) => elm.topLeftPoint.x === editPoint[0]?.topLeftPoint.x
  );

  useEffect(() => {
    if (index > -1) {
      let newArr2;
      if (numberKey && editPoint[0].type !== 'float' && confirmX && confirmY) {
        newArr2 = {
          type: editPoint[0].type,
          number: editPoint[0].number,
          label: editPoint[0].label,
          topLeftPoint: editPoint[0].topLeftPoint,
          topRightPoint: {
            x: (confirmX + 5) / width,
            y: (confirmY + 20) / height,
          },
          widthScreenshot: editPoint[0].widthScreenshot,
          heightScreenshot: editPoint[0].heightScreenshot,
          screenPosition: {
            x: editPoint[0].screenPosition.x,
            y: editPoint[0].screenPosition.y,
          },
        };
        const uniqueSet = [...newArrMove];
        let checkDuplicate = dataDiagram.findIndex(
          (element1) => element1.label === newArr2.label
        );
        if (checkDuplicate > -1) {
          uniqueSet[checkDuplicate] = newArr2;
          setNewArrMove(uniqueSet);
        } else {
          setNewArrMove([...newArrMove, newArr2]);
        }
      }
    }
  }, [index, confirmX, confirmY, numberKey, isEdit]);

  useEffect(() => {
    if (isDraw || isEdit) {
      setDisableUpload(true);
      dispatch(tenantAttributeInfos({ token }));
    } else setDisableUpload(false);
  }, [isDraw, isEdit]);

  const handleDraw = () => {
    setDraw(true);
    setDelete(false);
  };

  const handleSaveActionDiagram = async () => {
    const filteredData = [];
    const seen = {};

    for (let i = 0; i < arrMachine.length; i++) {
      const item = arrMachine[i];
      const key = `${item.type}_${item.number}`;

      if (!seen[key]) {
        seen[key] = true;
        filteredData.push(item);
      }
    }
    await dispatch(
      saveOperationDataDiagram({ token, deviceId, arrMachine: filteredData })
    );
    await dispatch(tenantAttributeInfos({ token }));
    setDraw(false);
    setArrMachine([]);
  };

  const handleCancelActionDiagram = () => {
    setDraw(false);
    setArrMachine([]);
  };

  const handleCancelResizeFloat = () => {
    setEdit(false);
    dispatch(isCancel(true));
    setNewArrMove([]);
  };

  const handleSaveResizeFloat = async () => {
    setEdit(false);
    let newArr = arrRectangles?.map((item) => ({
      type: 'float',
      number: item.id,
      label: item.label,
      topLeftPoint: item.topLeftPoint,
      topRightPoint: {
        x: (item.x + item.width) / width,
        y: item.y / height,
      },
      widthScreenshot: item.width / width,
      heightScreenshot: item.height / height,
      screenPosition: item.screenPosition,
    }));

    const existsInBothArrays = editFloat.filter(
      (element1) =>
        !newArrMove.map((element2) => element2?.label).includes(element1?.label)
    );
    let newArrMoveFilter = newArrMove.filter((element1) =>
      dataDiagram.map((element2) => element2?.label).includes(element1?.label)
    );
    let arrMachine = [...newArrMoveFilter, ...newArr, ...existsInBothArrays];

    dispatch(isCancel(false));
    await dispatch(saveOperationDataDiagram({ token, deviceId, arrMachine }));
    await dispatch(tenantAttributeInfos({ token }));
  };
  //new
  const [changeIcon, setChangeIcon] = useState(true);

  const handleShowCamera = () => {
    setShowCamera(!showCamera);
    
    !showCamera && dispatch(getCamera({ token, deviceId }));
  };

  return (
    <div className="control-diagram">
      <h4 className="control-left">{t('system-diagram')}</h4>
      <div className="control-right">
        {!isDraw ? (
          <Button
            disabled={isEdit || !isOperation}
            className={isEdit || !isOperation ? 'disabled' : null}
            variant="primary"
            onClick={handleDraw}
            title={t('draw')}
            style={{ float: 'left' }}
          >
            <Edit3 width={16} height={16} />
          </Button>
        ) : (
          <Button
            disabled={isEdit}
            variant="danger"
            onClick={handleCancelActionDiagram}
            title={t('cancel')}
            style={{ float: 'left' }}
          >
            <X width={16} height={16} />
          </Button>
        )}
        {!isEdit ? (
          <Button
            disabled={isDraw || !isOperation}
            className={isDraw || !isOperation ? 'disabled' : null}
            variant="primary"
            onClick={() => setEdit(true)}
            title={t('edit')}
            style={{ float: 'left' }}
          >
            <Edit width={16} height={16} />
          </Button>
        ) : (
          <>
            <Button
              variant="danger"
              onClick={handleCancelResizeFloat}
              title={t('cancel')}
              style={{ float: 'left' }}
            >
              <X width={16} height={16} />
            </Button>
            <Button
              disabled={arrMachine?.length > 0 ? false : true}
              variant="primary"
              onClick={handleSaveResizeFloat}
              style={{ float: 'left' }}
              title={t('save')}
            >
              <Save width={16} height={16} />
            </Button>
          </>
        )}
        {isDraw && (
          <Button
            variant="primary"
            disabled={arrMachine?.length > 0 ? false : true}
            onClick={handleSaveActionDiagram}
            title={t('save')}
          >
            <Save width={16} height={16} />
          </Button>
        )}
        <Button
          variant="primary"
          onClick={handleShowCamera}
          title={t('monitor-scene')}
        >
          <Video width={16} height={16} />
        </Button>
        <UploadButton
          disabled={disableUpload || !isOperation}
          setUploadedFileName={setPreview}
          setShowDiagram={setShowDiagram}
        />
        <Button
          style={{
            margin: '0px',
            padding: '0px',
            height: '34px',
            width: '45px',
            display: 'flex',
            alignItems: 'center',
            border: 'none',
            background: '#ffff',
          }}
        >
          <div
            className="card-header-right"
            style={{ margin: '0px', padding: '0px' }}
          >
            <Dropdown id="dropdown" onToggle={() => setChangeIcon(!changeIcon)}>
              <Dropdown.Toggle variant="none" id="dropdown-basic">
                {changeIcon ? (
                  <BsThreeDots size={20} />
                ) : (
                  <BsChevronDown size={20} />
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {!isMaximize ? (
                  <Dropdown.Item
                    onClick={() => {
                      extendCard();
                    }}
                  >
                    <Icon.Maximize size={16} /> {t('extend')}
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    onClick={() => {
                      extendCard();
                    }}
                  >
                    <Icon.Minimize size={16} /> {t('restore')}
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  onClick={() => {
                    reload();
                  }}
                >
                  <Icon.RefreshCw size={16} /> {t('reload')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Button>
      </div>
      {showCamera && (
        <ModalCamera
          show={showCamera}
          setShow={setShowCamera}
          deviceId={deviceId}
        />
      )}
    </div>
  );
};

export default EditBar;
